import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import type { Observable } from 'rxjs';
import { Api } from 'src/app/core/api/Api';
import type { OverviewConfig } from '../overview/overview.model';

@Injectable({
  providedIn: 'root',
})
export class HomeService {
  constructor(private http: HttpClient) {}

  fetchOverview(): Observable<OverviewConfig> {
    return this.http.get(Api.Overview) as Observable<OverviewConfig>;
  }
}
